import React, { useState } from 'react';
import { useStore } from 'effector-react';
import { $customers, setCustomers } from '../store/cards';
import { deleteCustomer, getCustomers } from '../components/api';
import '../styles/admin.scss';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    IconButton
} from '@mui/material';
import { CustomerEditForm } from '../components';
import { Edit, Delete } from '@mui/icons-material';

const default_customer_value = {
    id: null,
    bitrix_code: 0,
    name: '',
}

export const CustomerPage = () => {
    const customers = useStore($customers);
    const [showEditForm, setShowEditForm] = useState(false);
    const [editedCustomer, setEditedCustomer] = useState(null);
    const [showDialogDelete, setShowDialogDelete] = useState(false);

    React.useEffect(() => {
        document.title = "TaskMan - заказчики";
    });

    React.useEffect(() => {
        getCustomers().then(data => setCustomers(data));
    }, [customers.length])

    const addCustomer = () => {
        setEditedCustomer(default_customer_value);
        setShowEditForm(true);
    };

    const editCustomer = (event, customer) => {
        setEditedCustomer(customer);
        setShowEditForm(true);
    };

    const deleteCustomerButtonClick = (event, customer) => {
        setEditedCustomer(customer);
        setShowDialogDelete(true);
    };

    const handleCloseDialog = (event, dialogResult) => {
        if (dialogResult) {
            deleteCustomer(editedCustomer.id);
            closeCallback();
        }
        setShowDialogDelete(false);
    };

    const closeCallback = () => {
        setTimeout(() => {
            getCustomers().then(data => setCustomers(data));
        }, 300);
    }
    return (
        <div>
            <Button variant="contained" id="add-button" onClick={addCustomer}>Добавить</Button>
            <div style={{ width: 1000 }}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 610 }} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Наименование</b></TableCell>
                                <TableCell><b>Код битрикс</b></TableCell>
                                <TableCell><b>Цвет</b></TableCell>
                                <TableCell><b>Действия</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {customers.map(customer => {
                                return (
                                    <TableRow key={customer.id} hover={true} style={{ background: customer.color + 'b3' }}>
                                        <TableCell width={200}>{customer.name}</TableCell>
                                        <TableCell width={150}>{customer.bitrix_code}</TableCell>
                                        <TableCell width={130}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                <div style={{ width: 10, height: 10, background: customer.color, marginRight: 5 }}></div>
                                                {customer.color}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={(event) => editCustomer(event, customer)} sx={{ padding: 0, marginLeft: 1, marginRight: 1 }}>
                                                <Edit sx={{ fontSize: 20 }} />
                                            </IconButton>
                                            <IconButton onClick={(event) => deleteCustomerButtonClick(event, customer)} sx={{ padding: 0, marginLeft: 1, marginRight: 1 }}>
                                                <Delete sx={{ fontSize: 20 }} />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            {showEditForm ? <CustomerEditForm setShowEditForm={setShowEditForm} customer={editedCustomer} closeCallback={closeCallback}></CustomerEditForm> : null}
            <Dialog
                open={showDialogDelete}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Вы уверенны, что хотите удалить заказчика?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(event) => handleCloseDialog(event, true)} color="primary">
                        Да
                    </Button>
                    <Button onClick={(event) => handleCloseDialog(event, false)} color="primary" autoFocus>
                        Нет
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}